var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageBlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 0.625C1.25 0.28125 0.96875 0 0.625 0C0.28125 0 0 0.28125 0 0.625V2.5V14.3359V15.625V19.375C0 19.7188 0.28125 20 0.625 20C0.96875 20 1.25 19.7188 1.25 19.375V15.3125L5.01172 14.3711C6.61719 13.9688 8.31641 14.1562 9.79688 14.8945C11.5234 15.7578 13.5273 15.8633 15.332 15.1836L16.6875 14.6758C17.1758 14.4922 17.5 14.0273 17.5 13.5039V2.58203C17.5 1.68359 16.5547 1.09766 15.75 1.5L15.375 1.6875C13.5664 2.59375 11.4375 2.59375 9.62891 1.6875C8.25781 1 6.68359 0.828125 5.19531 1.19922L1.25 2.1875V0.625ZM1.25 3.47656L5.49609 2.41406C6.69531 2.11328 7.96094 2.25391 9.06641 2.80469C11.2266 3.88672 13.7695 3.88672 15.9336 2.80469L16.25 2.64453V13.5039L14.8945 14.0117C13.4141 14.5664 11.7695 14.4805 10.3555 13.7734C8.60938 12.8984 6.60547 12.6797 4.71094 13.1523L1.25 14.0234V3.47656Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageBlock);
export default __webpack_public_path__ + "static/media/messageBlock.b2defb40ee2e2c19b79ad5468dd739e8.svg";
export { ForwardRef as ReactComponent };